// =====================================================================
// PrerollsListVideoExt.jsx — lista PREROLL VIDEO con paging 10/volta
// =====================================================================
import React, { useEffect, useState } from 'react'
import api        from '../../services/api'
import Loader     from '../Utils/Loader'
import Modal      from '../common/Modal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faTrash, faToggleOn, faToggleOff, faPlay } from '@fortawesome/free-solid-svg-icons'
import '../../css/prerollsList.css'

const API_BASE    = '/prerolls-ext'
const placeholder = '/img/placeholder-cover.jpg'
const PAGE_SIZE   = 10

export default function PrerollsListVideoExt({ onEdit, onChange, refreshKey }) {
  const [rows,   setRows]    = useState([])
  const [loading,setLoading] = useState(true)
  const [search, setSearch]  = useState('')
  const [preview,setPreview] = useState(null)
  const [page,   setPage]    = useState(1)

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(API_BASE)
        setRows(data.filter(r => r.mediaType === 'video'))
      } finally { setLoading(false) }
    })()
  }, [refreshKey])

  useEffect(() => { setPage(1) }, [search, refreshKey])

  if (loading) return <Loader />

  const handleDelete = async id => {
    if (!window.confirm('Vuoi eliminare questo preroll?')) return
    await api.delete(`${API_BASE}/${id}`)
    onChange()
  }
  const handleToggle = async r => {
    await api.put(`${API_BASE}/${r.id}`, { enabled: !r.enabled })
    onChange()
  }

  const filtered = rows.filter(r =>
    r.filename?.toLowerCase().includes(search.toLowerCase())
  )
  const visible  = filtered.slice(0, page * PAGE_SIZE)
  const hasMore  = visible.length < filtered.length
  const loadMore = () => setPage(p => p + 1)

  return (
    <div className="preroll-list">
      <div className="preroll-list-search">
        <input className="preroll-search" placeholder="Cerca filename…"
               value={search} onChange={e => setSearch(e.target.value)} />
      </div>

      <div className="preroll-list-items" aria-live="polite">
        <div className="preroll-row head">
          <span>ID</span><span>Nome</span><span>Dal</span><span>Al</span>
          <span>Cover</span><span>Tipo</span><span>Ordine</span>
          <span className="actions">Azioni</span>
        </div>

        {visible.map(r => (
          <div key={r.id} className="preroll-row body">
            <span>{r.id}</span><span className="filename">{r.filename}</span>
            <span>{r.startTime ? new Date(r.startTime).toLocaleString('it-IT') : '—'}</span>
            <span>{r.endTime   ? new Date(r.endTime  ).toLocaleString('it-IT') : '—'}</span>
            <div className="cover">
              <img src={r.coverUrl || placeholder} alt=""
                   loading="lazy" onClick={() => setPreview(r)} tabIndex={0} />
            </div>
            <span>{r.type}</span><span>{r.prio}</span>
            <div className="actions">
              <button onClick={() => setPreview(r)}><FontAwesomeIcon icon={faPlay} /></button>
              <button onClick={() => onEdit(r)}   ><FontAwesomeIcon icon={faEdit} /></button>
              <button onClick={() => handleDelete(r.id)}><FontAwesomeIcon icon={faTrash} /></button>
              <button onClick={() => handleToggle(r)}   ><FontAwesomeIcon icon={r.enabled ? faToggleOn : faToggleOff} /></button>
            </div>
          </div>
        ))}

        {hasMore && (
          <div className="preroll-row load-more">
            <button className="btn-load-more" onClick={loadMore}>
              Carica altri…
            </button>
          </div>
        )}
      </div>

      <Modal open={Boolean(preview)} onClose={() => setPreview(null)}>
        {preview &&
          <video src={preview.url} controls style={{ maxWidth:'100%', maxHeight:'60vh' }} />}
      </Modal>
    </div>
  )
}
